import { Injectable } from '@angular/core';
import { GlobalSettings } from './global.settings';
import { AuthenticateUserService } from './authenticateuser.service';
import { Router } from '@angular/router';
import Utils from './utils';
import { IndexedDBService } from './services/indexed-db.service';
import {CommonService} from './common.service';

@Injectable()
export class CommonTaxonomyProject {
    projectClickablePermission = {};
    indPermissionLoaded = true; // holds boolean for loading inv project permission

    constructor(
        private router: Router,
        private indexedDBService: IndexedDBService,
        private AuthenticateUser: AuthenticateUserService,
        private service: CommonService,
    ) {}

    checkProjectCanBeClickable(project_id, selectedStageId) {
        let isClickable = this.AuthenticateUser.AuthenticProjectPermissions(
            'View Associated Nodes'
        );
        const editProject = Utils.checkProjectPermission(
            project_id,
            'View Associated Nodes',
            'project_permissions',
            selectedStageId,
            'project_role_permissions'
        );
        if (editProject && editProject.hasProject) {
            isClickable = editProject.valid;
        }
        return isClickable;
    }

    getPermission(project_id, selectedStageId) {
        if (this.projectClickablePermission[project_id]) {
            return this.projectClickablePermission[project_id];
        }
        const value = this.checkProjectCanBeClickable(project_id, selectedStageId);
        this.projectClickablePermission[project_id] = value;
        return value;
    }

    getProjectSpecificPermission(id) {
        this.indPermissionLoaded = false;
        const url = GlobalSettings.GET_PROJECT_PERMISSION + '?project_id=' + id;
        this.service.getServiceData(url).then((res: any) => {
            console.log('project permission', res);
            this.indPermissionLoaded = true;
            Utils.individualProjectPermissions = res;
            this.indexedDBService.addData(res, 'individual_project_role_permissions');
            const urlPrefix = GlobalSettings.BASE_URL.replace('server/', Utils.baseTag + '#')
                .replace('api.', '') + this.service.getOrgDetails();
            const path = urlPrefix + '/' + Utils.ROUTE_PROJECT_DETAIL + '/' + id;
            this.router.navigate([]).then(result => {  window.open(path, '_blank'); });
        });
    }
}
